const FUCSIA = "#CC4BA4"
const GREY = "#656565"
const BLACK = "#2B2B2B"

export { FUCSIA, GREY, BLACK }